export class Component {
  constructor({ $el, $componentName, $uuid }) {
    this.$el = $el
    this.$componentName = $componentName
    this.$uuid = $uuid
    this.$ui = {}
  }

  ui() {}

  created() {}
}
